import React, { useImperativeHandle, useMemo, useState, useRef } from 'react'
import { Picker } from 'antd-mobile'
import { IDpPickerProps, formatFunc, transformChangeSubmit } from './utils'
import { useDebounce } from '@/libs/functions/tools'
import { SET_COLUMNS } from './columns'
import pick from 'lodash/pick'

// 暂时只考虑时间
const DatePicker: React.FC<IDpPickerProps> = (props) => {
  const { format = 'HH:mm', value }= props
  const [currentSelect, updateCurrentSelect] = useState<string[]>(formatFunc(value)) // 滚动选择的值
  const prvTime: any = useRef()

  //用useImperativeHandle暴露一些外部ref能访问的属性
  useImperativeHandle(props.onRef, () => {
    return {
      setUpdateVisible,
    }
  })

  const _format = useMemo(() => formatFunc(format), [format])
  const columns = useMemo(() => {
    return SET_COLUMNS({
      currentValue: currentSelect,
      _format,
      extra: pick(props, ['config', 'disabled', 'format', 'type', 'disabledTime'])
    })
  }, [_format, currentSelect, props?.disabledTime])
  const setUpdateVisible = () => {
    updateCurrentSelect(formatFunc(value))
  }
  const onCgDebounce = useDebounce(
    (e: any) => updateCurrentSelect(prvTime.current), 500
    
  )

  return (
    <Picker
      title={props?.title || '选择时间'}
      columns={columns}
      visible={props?.visible}
      {...props?.pickerProps}
      style={props?.pickerProps?.style}
      value={formatFunc(props?.value) || Array.from({ length: _format?.length }, (_, i) => {
        return '' 
      })}
      onSelect={(v: number[], extend) => {
        prvTime.current = v
        onCgDebounce(v)
      }}
      onConfirm={(v: number[]) => {
        props?.onCancel?.(!props?.visible)
        props?.onChange?.(transformChangeSubmit(format, _format, v))
      }}
      onCancel = {() => {
        props?.onCancel?.(!props?.visible)
        props?.onChange?.(null)
      }}
    />
  )
}

export default DatePicker
